(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335,2610,40659,81066,75847,44709,40852,81243,74453,44954,40617,68837,19341,97],{

/***/ 48105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(84118);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 2610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26033);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42222);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var PageHeader = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, titleStyles = param.titleStyles, breadcrumbsStyles = param.breadcrumbsStyles, breadcrumbsTheme = param.breadcrumbsTheme, updatedAt = param.updatedAt, type = param.type, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs,
                className: breadcrumbsStyles,
                type: type,
                dark: breadcrumbsTheme === "dark"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleStyles, titleStyles), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                    children: [
                        updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().updatedAt),
                            children: "Last updated: ".concat((0,utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(updatedAt))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: title
                        }),
                        children
                    ]
                }))
            })
        ]
    });
};
PageHeader.defaultProps = {
    title: "",
    breadcrumbs: null,
    titleStyles: "",
    breadcrumbsStyles: ""
};
PageHeader.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbs: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Array),
    titleStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbsStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 77443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_ImageSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/ImageSection/utils/useSectionProps.js



/* harmony default export */ function useSectionProps(param) {
    var section = param.section, type = param.type, handleOnCTAClick = param.handleOnCTAClick;
    var ref = (0,react.useMemo)(function() {
        return (0,helper/* getDocumentFields */.OA)(section, [
            "title",
            "description",
            "formattedDescription",
            "images",
            "contentModules",
            "view", 
        ]);
    }, [
        section
    ]), title = ref.title, description = ref.description, formattedDescription = ref.formattedDescription, images = ref.images, contentModules = ref.contentModules, view = ref.view;
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", {}), [
        "text"
    ]), _text = ref1.text, text = _text === void 0 ? "" : _text;
    var link = get_default()(contentModules, "[1]", null);
    var imageUrl = (0,helper/* getFileUrl */.qm)(get_default()(images, "[0]"));
    return {
        title: title,
        description: description,
        text: text,
        imageUrl: imageUrl,
        type: type,
        view: view,
        link: link,
        handleOnCTAClick: handleOnCTAClick,
        formattedDescription: formattedDescription
    };
};

// EXTERNAL MODULE: ./UI/sections/ImageSection/styles.module.scss
var styles_module = __webpack_require__(13373);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/ImageSection/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ContentfulParser = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 92870));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92870)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 49617).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var ImageSection = function(props) {
    var ref = useSectionProps(props), title = ref.title, description = ref.description, formattedDescription = ref.formattedDescription, text = ref.text, imageUrl = ref.imageUrl, type = ref.type, view = ref.view, link = ref.link, handleOnCTAClick = ref.handleOnCTAClick;
    if (!imageUrl) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).imageSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).image,
                            style: {
                                backgroundImage: "url(".concat(imageUrl, ")")
                            }
                        })
                    })),
                    text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).experienceContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                                title: title,
                                description: description,
                                formattedDescription: formattedDescription,
                                type: "side",
                                titleStyle: (styles_module_default()).titleStyle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                    document: text
                                })
                            }))
                        ]
                    })
                ]
            }),
            !!link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                    data: link,
                    handleOnClick: handleOnCTAClick,
                    className: (styles_module_default()).callToAction
                })
            }))
        ]
    });
};
ImageSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_ImageSection = (ImageSection);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 38067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/microdata/data.js
var data = __webpack_require__(13107);
// EXTERNAL MODULE: ./utils/microdata/utils.js
var utils = __webpack_require__(20281);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./utils/microdata/deprecatedData.js




var _obj;
// TODO: Replace with actual data ASAP
var deprecatedData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareDevelopmentPrice.slug */.y2.softwareDevelopmentPrice.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Pricing: Hire a Team for Your Project | Yellow",
    description: "Calculate how much money you will need to build your software.\n    We only bill for the time actually spent on work, so it's easy to manage the budget. No extra fees.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.penetrationTesting.slug */.y2.penetrationTesting.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Penetration testing  | Yellow",
    description: "Use penetration testing to make sure your software solution is safe for your users. " + "Yellow will provide you with penetration testing services.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customMobileApp.slug */.y2.customMobileApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom mobile app development company | Yellow",
    description: "The best talents for Mobile App Development are here. Hire an experienced team to work on your idea.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.iosDevelopmentServices.slug */.y2.iosDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "iOS Mobile App Development Company | Yellow",
    description: "Yellow can provide you with iOS development services. If you want to create an iPhone or " + "iPad app, we are here to help.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.androidDevelopmentServices.slug */.y2.androidDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom Android App Development Company | Yellow",
    description: "Yellow is ready to provide you with Android development services to bring your idea to life.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.prototypingServices.slug */.y2.prototypingServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Mobile App Prototyping Services | Yellow",
    description: "Prototyping is an important stage in mobile app development. Complete it with Yellow!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customWebApp.slug */.y2.customWebApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Web Application Development Services | Yellow",
    description: "Our team is ready to provide you with web development services. " + "We are working with websites, PWAs, chatting applications, and landing pages.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareQualityAssuranceServices.slug */.y2.softwareQualityAssuranceServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Software Quality Assurance and Testing Services | Yellow",
    description: "Quality assurance is an important part of software product creation since it ensures that users" + " will receive a convenient and fully-functional solution. If you need QA services, Yellow is ready to provide them!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crowdfundingPlatform.slug */.y2.crowdfundingPlatform.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Crowdfunding Platform Development Company | Yellow",
    description: "Yellow is ready to provide you with crowdfunding platform development services. " + "High quality, realistic budget estimate, fast speed.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.fintechDevelopment.slug */.y2.fintechDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Fintech Software Development Services | Yellow",
    description: "The fintech industry is booming and doesn't seem to stop. Let's see how your " + "idea can take the slice of pie?",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.designServices.slug */.y2.designServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "UI/UX design services | Yellow",
    description: "Visual content matters, that is where UI/UX design comes into play.Users love good-looking " + "software. Make mobile your app or website captivating with Yellow.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.discoveryPhase.slug */.y2.discoveryPhase.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Project Discovery Phase in Custom Software Development | Yellow",
    description: "Discovery phase of a project is an important part of software development. " + "Learn more about how Yellow runs a discovery phase to benefit your business."
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.eWalletAppDevelopment.slug */.y2.eWalletAppDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "E-Wallet App Development Company | Yellow",
    description: "Mobile e-wallet app development services for any industry and any business scale.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.bankingSoftwareDevelopmentCompany.slug */.y2.bankingSoftwareDevelopmentCompany.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Banking Software Development Company | Yellow",
    description: "We provide companies and organizations big and small with outstanding banking software " + "development. Check out what we can do for you.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.deliveryQualityInYellow.slug */.y2.deliveryQualityInYellow.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "What Makes Yellow a Good Software Development Partner | Yellow",
    description: "Delivery quality standards we follow to build a perfect project for YOU.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.pwaDevelopmentServices.slug */.y2.pwaDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "PWA Development Services | Yellow",
    description: "Yellow is combining web and mobile worlds and creates progressive web " + "apps that function smoothly on all devices.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.paymentGatewayDevelopment.slug */.y2.paymentGatewayDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Payment Software Gateway Development Company | Yellow",
    description: "Yellow is a leading Payment Gateway Development company, providing customized " + "solutions to enhance transaction security and accuracy. Read more about our services now.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.billingSoftwareDevelopment.slug */.y2.billingSoftwareDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Billing Software Development Services Company | Yellow",
    description: "If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crossPlatformDevelopmentServices.slug */.y2.crossPlatformDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Cross-Platform App Development Services | Yellow",
    description: "Your cross-platform application will rock the stage and Yellow is ready to make it happen.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.devOpsDevelopment.slug */.y2.devOpsDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "DevOps Development Company | Yellow",
    description: "If your company wants to integrate DevOps service into its processes and get all " + "the benefits this technology offers, Yellow is ready to lend a hand!",
    image: data/* logoUrl */.pt
}), _obj);

;// CONCATENATED MODULE: ./utils/microdata/index.js






function getPageMicrodata(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, breadcrumbs = ref.breadcrumbs, microData = ref.microData;
    var microdataArray = [
        // TODO: uncomment when deprecated data will be replaced
        // webpageMicrodata,
        data/* websiteMicrodata */.IR,
        data/* organisationMicrodata */.nW, 
    ];
    var breadcrumbsMicrodata = (0,utils/* getBreadcrumbsMicrodata */.js)(breadcrumbs);
    if (breadcrumbsMicrodata) {
        microdataArray.push(breadcrumbsMicrodata);
    }
    switch(page){
        case constants/* ROUTES.homepage.slug */.y2.homepage.slug:
        case constants/* ROUTES.contact.slug */.y2.contact.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            break;
        case constants/* ROUTES.company.slug */.y2.company.slug:
        case constants/* ROUTES.whyUs.slug */.y2.whyUs.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            microdataArray.push(data/* aboutPageMicrodata */.WN);
            break;
        case constants/* ROUTES.blog.slug */.y2.blog.slug:
        case constants/* ROUTES.portfolio.slug */.y2.portfolio.slug:
        case constants/* ROUTES.project.slug */.y2.project.slug:
        case constants/* ROUTES.process.slug */.y2.process.slug:
        case constants/* ROUTES.termsAndConditions.slug */.y2.termsAndConditions.slug:
        case constants/* ROUTES.cookiesPolicy.slug */.y2.cookiesPolicy.slug:
        case constants/* ROUTES.privacyPolicy.slug */.y2.privacyPolicy.slug:
            break;
        case constants/* ROUTES.article.slug */.y2.article.slug:
            microdataArray.push((0,utils/* getArticleMicrodata */.WK)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, microData), {
                organisationMicrodata: data/* organisationMicrodata */.nW
            })));
            break;
        case constants/* ROUTES.person.slug */.y2.person.slug:
            microdataArray.push((0,utils/* getPersonMicrodata */.RK)(microData));
            break;
        default:
            var currentRoute = Object.values(constants/* ROUTES */.y2).find(function(route) {
                return route.slug === page;
            });
            var oldData = deprecatedData[page];
            if (oldData) {
                microdataArray.push(oldData);
                break;
            }
            microdataArray.push((0,utils/* getServiceMicrodata */.fi)(currentRoute, {
                organisationMicrodata: data/* organisationMicrodata */.nW,
                category: data/* CATEGORY */.En[page],
                offers: data/* OFFERS */.jn[page],
                addresses: data/* addresses */.UB
            }));
            break;
    }
    return microdataArray;
}

;// CONCATENATED MODULE: ./components/Common/MetaTags/utils/data.js
var defaultMetadata = {
    title: "Trusted AI Transformation Agency | Yellow",
    description: "We help businesses turn their AI initiatives into production-grade solutions with measurable results."
};

;// CONCATENATED MODULE: ./components/Common/MetaTags/index.jsx
/* eslint-disable react/jsx-max-props-per-line */ 






var MetaTags = function(param) {
    var page = param.page, pageMetadata = param.pageMetadata, children = param.children, breadcrumbs = param.breadcrumbs, microData = param.microData, isArticle = param.isArticle;
    var metaTitle = pageMetadata.metaTitle, metaDescription = pageMetadata.metaDescription, metaRobots = pageMetadata.metaRobots, image = pageMetadata.image, publishedAt = pageMetadata.publishedAt, categoryTag = pageMetadata.categoryTag, keyWords = pageMetadata.keyWords, pageNumber = pageMetadata.pageNumber, url = pageMetadata.url, ogImage = pageMetadata.ogImage;
    var microdata = getPageMicrodata(page, {
        breadcrumbs: breadcrumbs,
        microData: microData
    });
    var getTitle = function() {
        return pageNumber > 1 ? "".concat(metaTitle || defaultMetadata.title, " | Page ").concat(pageNumber) : metaTitle || defaultMetadata.title;
    };
    var getDescription = function() {
        return pageNumber > 1 ? "".concat(metaDescription || defaultMetadata.description, " | Page ").concat(pageNumber) : metaDescription || defaultMetadata.description;
    };
    var getImage = function() {
        if (ogImage) return ogImage;
        if (isArticle) return image;
        return (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png");
    };
    var date = isArticle ? publishedAt : new Date();
    var type = isArticle ? "article" : "website";
    var title = getTitle();
    var description = getDescription();
    var robots = !constants/* IS_PROD */.XK ? "none" : metaRobots;
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "date",
                content: date
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: getImage()
            }),
            categoryTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: categoryTag
            }),
            publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedAt
            }),
            keyWords === null || keyWords === void 0 ? void 0 : keyWords.map(function(keyWord) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "article:tag",
                    content: keyWord
                }, "meta/tag/".concat(keyWord));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (0,helper/* getPathWithCdn */.d6)("/yellow_logo.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: (0,helper/* getPathWithCdn */.d6)("/safari-pinned-tab.svg"),
                color: "#ffbf02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "application/ld+json/microdata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(microdata, null, 2)
                }
            })
        ]
    }));
};
MetaTags.defaultProps = {
    children: null,
    pageMetadata: {},
    articleData: {},
    breadcrumbs: [],
    isArticle: false
};
MetaTags.propTypes = {
    page: (prop_types_default()).string.isRequired,
    breadcrumbs: prop_types_default().instanceOf(Array),
    articleData: prop_types_default().instanceOf(Object),
    pageMetadata: prop_types_default().shape({
        metaTitle: (prop_types_default()).string,
        metaDescription: (prop_types_default()).string,
        metaRobots: (prop_types_default()).string,
        image: (prop_types_default()).string,
        ogImage: (prop_types_default()).string,
        publishedAt: (prop_types_default()).string,
        categoryTag: (prop_types_default()).string,
        keyWords: prop_types_default().instanceOf(Array),
        pageNumber: (prop_types_default()).number
    }),
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array,
        (prop_types_default()).element, 
    ]),
    isArticle: (prop_types_default()).bool,
    defaultMetaData: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var Common_MetaTags = (MetaTags);


/***/ }),

/***/ 22116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(321);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var FullLayout = function(param) {
    var children = param.children, disableMaxWidth = param.disableMaxWidth, disableTopPadding = param.disableTopPadding, disableSidePadding = param.disableSidePadding, disableBottomPadding = param.disableBottomPadding, disableOverflowHiding = param.disableOverflowHiding, backgroundColor = param.backgroundColor, introSection = param.introSection, className = param.className;
    var _obj;
    var layoutStyles = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullLayout), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[backgroundColor], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableMaxWidth), disableMaxWidth), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableTopPadding), disableTopPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableSidePadding), disableSidePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableBottomPadding), disableBottomPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableOverflowHiding), disableOverflowHiding), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: layoutStyles,
        ref: introSection,
        children: children
    });
};
FullLayout.defaultProps = {
    children: {},
    disableMaxWidth: false,
    disableTopPadding: false,
    disableSidePadding: false,
    disableBottomPadding: false,
    backgroundColor: "",
    introSection: null
};
FullLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    disableMaxWidth: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableTopPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableSidePadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableBottomPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    introSection: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["Z"] = (FullLayout);


/***/ }),

/***/ 84118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 3 modules
var MetaTags = __webpack_require__(38067);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
// EXTERNAL MODULE: ./UI/sections/ImageSection/index.jsx + 1 modules
var ImageSection = __webpack_require__(77443);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
;// CONCATENATED MODULE: ./UI/components/FieldsWrapper/index.jsx



var FieldsWrapper = function(param) {
    var type = param.type, path = param.path, subtitle = param.subtitle, className = param.className;
    switch(type){
        case "phone":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                path: path,
                isLocalLink: true,
                className: className,
                googleAnalyticProps: {
                    action: "Click",
                    data: "Phone"
                },
                children: subtitle
            });
        case "navigation":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                path: path,
                className: className,
                isLocalLink: true,
                children: subtitle
            });
        default:
            return null;
    }
};
FieldsWrapper.propTypes = {
    type: (prop_types_default()).string.isRequired,
    path: (prop_types_default()).string.isRequired,
    subtitle: (prop_types_default()).string.isRequired
};

// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/CompanyLocation/CompanyLocation.module.scss
var CompanyLocation_module = __webpack_require__(45137);
var CompanyLocation_module_default = /*#__PURE__*/__webpack_require__.n(CompanyLocation_module);
;// CONCATENATED MODULE: ./UI/components/CompanyLocation/index.jsx





var CompanyLocation = function(param) {
    var addresses = param.addresses, containerClass = param.containerClass, itemClass = param.itemClass, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((CompanyLocation_module_default()).container, containerClass, className),
        children: addresses.map(function(param) {
            var title = param.title, text = param.text, path = param.path, pathText = param.pathText, type = param.type;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        className: (CompanyLocation_module_default()).addressTitle,
                        "data-title": true,
                        children: title
                    }),
                    Array.isArray(text) ? text.map(function(textItem) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            className: (CompanyLocation_module_default()).addressText,
                            "data-text": true,
                            children: textItem
                        }, textItem);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        className: (CompanyLocation_module_default()).addressText,
                        "data-text": true,
                        children: text
                    }),
                    path && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsWrapper, {
                        className: (CompanyLocation_module_default()).addressText,
                        type: type,
                        path: path,
                        subtitle: pathText
                    })
                ]
            }, title);
        })
    });
};
/* harmony default export */ var components_CompanyLocation = (CompanyLocation);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-map-gl/dist/esm/index.js + 73 modules
var esm = __webpack_require__(43971);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
;// CONCATENATED MODULE: ./UI/components/CompanyLocationMap/utils/data.js
var markers = {
    USA: {
        lng: -122.398559,
        lat: 37.7888956
    },
    Poland: {
        lng: 20.986031099330717,
        lat: 52.23421983438129
    },
    Argentina: {
        lng: -58.3853582,
        lat: -34.6040643
    }
};
var MAPBOX_TOKEN = "pk.eyJ1IjoieWVsbG93LXN5c3RlbXMiLCJhIjoiY2s3a2owamI5MDJnbzNocXdwc2RhdjZycSJ9.PLCIBfxS9R6dnrvE94TcXw";
var INITIAL_MAP_ZOOM = 1;
var INITIAL_MAP_MOBILE_ZOOM = 0.6;
var INITIAL_MAP_LNG = -40.539046499999266;
var INITIAL_MAP_LAT = 17.515557952842894;

// EXTERNAL MODULE: ./UI/components/CompanyLocationMap/styles.module.scss
var styles_module = __webpack_require__(17002);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/CompanyLocationMap/index.jsx











var Map = function() {
    var isMobile = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var ref = (0,react.useState)({
        latitude: INITIAL_MAP_LAT,
        longitude: INITIAL_MAP_LNG,
        zoom: INITIAL_MAP_ZOOM
    }), viewport = ref[0], setViewport = ref[1];
    var handleViewportChange = (0,react.useCallback)(function(newViewport) {
        return setViewport(newViewport);
    }, []);
    (0,react.useEffect)(function() {
        if (!isMobile) {
            return;
        }
        setViewport(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                zoom: INITIAL_MAP_MOBILE_ZOOM
            });
        });
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).map,
        children: viewport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewport), {
            width: "auto",
            height: "100%",
            onViewportChange: handleViewportChange,
            mapboxApiAccessToken: MAPBOX_TOKEN,
            scrollZoom: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* NavigationControl */.Pv, {
                    className: (styles_module_default()).controlPanel
                }),
                Object.entries(markers).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), country = _param[0], marker = _param[1];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                        longitude: marker.lng,
                        latitude: marker.lat,
                        anchor: "bottom",
                        className: (styles_module_default()).marker,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: "defaultLogo"
                        })
                    }, country);
                })
            ]
        }))
    });
};
/* harmony default export */ var CompanyLocationMap = (Map);

// EXTERNAL MODULE: ./utils/constants/contacts.js
var contacts = __webpack_require__(32522);
;// CONCATENATED MODULE: ./UI/components/CompanyLocation/utils/data.js

var addresses = [
    {
        title: "In USA",
        text: contacts/* PLACEMENT_DATA.USA */.zm.USA
    },
    {
        title: "In Argentina",
        text: contacts/* PLACEMENT_DATA.Argentina */.zm.Argentina
    },
    {
        title: "Poland",
        text: contacts/* PLACEMENT_DATA.Poland */.zm.Poland
    }, 
];
var addressesForContactUs = [
    addresses[0],
    addresses[2],
    addresses[1], 
];

// EXTERNAL MODULE: ./UI/sections/CompanyPlacementWithMap/CompanyPlacementWithMap.module.scss
var CompanyPlacementWithMap_module = __webpack_require__(39323);
var CompanyPlacementWithMap_module_default = /*#__PURE__*/__webpack_require__.n(CompanyPlacementWithMap_module);
;// CONCATENATED MODULE: ./UI/sections/CompanyPlacementWithMap/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var CompanyPlacementWithMap = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (CompanyPlacementWithMap_module_default()).companyPlacement,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompanyPlacementWithMap_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                        title: "Our offices",
                        className: (CompanyPlacementWithMap_module_default()).title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyLocation, {
                            addresses: addressesForContactUs,
                            itemClass: (CompanyPlacementWithMap_module_default()).address,
                            containerClass: (CompanyPlacementWithMap_module_default()).addressesContainer,
                            className: className
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLocationMap, {})
            }))
        ]
    });
};
/* harmony default export */ var sections_CompanyPlacementWithMap = (CompanyPlacementWithMap);

// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/index.jsx + 5 modules
var FeedbackForm = __webpack_require__(49163);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var components_LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/components/Contacts/Contacts.module.scss
var Contacts_module = __webpack_require__(32156);
var Contacts_module_default = /*#__PURE__*/__webpack_require__.n(Contacts_module);
;// CONCATENATED MODULE: ./UI/components/Contacts/index.jsx








function Contacts(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                        className: (Contacts_module_default()).contactHeadline,
                        children: "Phones:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkWrapper/* default */.Z, {
                        path: "tel:".concat(contacts/* PHONE_NUMBER.us */.UE.us),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                            className: (Contacts_module_default()).contact,
                            isBold: true,
                            children: contacts/* PHONE_NUMBER.us */.UE.us
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkWrapper/* default */.Z, {
                        path: "mailto:".concat(contacts/* EMAIL_LINK */.Vr),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                            className: (Contacts_module_default()).contact,
                            isBold: true,
                            children: contacts/* EMAIL_LINK */.Vr
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                        className: (Contacts_module_default()).contactHeadline,
                        children: "Follow:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Contacts_module_default()).smList,
                        children: Object.values(contacts/* SOCIAL_MEDIA */.CL).filter(function(sm) {
                            return sm.id !== "dribbble";
                        }).map(function(sm) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkWrapper/* default */.Z, {
                                path: sm.link,
                                className: (Contacts_module_default()).smItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                    type: sm.iconDark
                                })
                            }, sm.link);
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_Contacts = (Contacts);

// EXTERNAL MODULE: ./redux/apis/page.js
var page = __webpack_require__(85144);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/views/ContactUs/utils/useContactUsProps.js






/* harmony default export */ function useContactUsProps(param) {
    var type = param.type, ssrContentModules = param.contentModules, metaFromProps = param.metaData;
    var ref = (0,page/* useFetchPageQuery */.oO)(type, {
        skip: Boolean(ssrContentModules)
    }), _data = ref.data, data = _data === void 0 ? {} : _data;
    var ref1;
    var contentModules = (ref1 = ssrContentModules !== null && ssrContentModules !== void 0 ? ssrContentModules : data.contentModules) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var metaData = (ref2 = metaFromProps !== null && metaFromProps !== void 0 ? metaFromProps : data.metaData) !== null && ref2 !== void 0 ? ref2 : {};
    var pageMetadata = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaData), {
        url: "".concat(helper/* rootUrl */.Wd, "/contact")
    });
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.contact */.q5.contact);
    var peoplePhotoSection = (0,helper/* findBlock */.CL)(contentModules, constants/* BLOCKS_SLUGS.contactPageCompanyPhoto */.KN.contactPageCompanyPhoto);
    return {
        peoplePhotoSection: peoplePhotoSection,
        pageMetadata: pageMetadata,
        breadcrumbs: breadcrumbs
    };
};

// EXTERNAL MODULE: ./UI/views/ContactUs/ContactUs.module.scss
var ContactUs_module = __webpack_require__(60853);
var ContactUs_module_default = /*#__PURE__*/__webpack_require__.n(ContactUs_module);
;// CONCATENATED MODULE: ./UI/views/ContactUs/index.jsx














var ContactUs = function(props) {
    var ref = useContactUsProps(props), breadcrumbs = ref.breadcrumbs, pageMetadata = ref.pageMetadata, peoplePhotoSection = ref.peoplePhotoSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.contact */.q5.contact,
                pageMetadata: pageMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullLayout/* default */.Z, {
                disableOverflowHiding: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        breadcrumbs: breadcrumbs,
                        breadcrumbsTheme: "dark"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                        title: "Got a project in mind?",
                        titleStyle: (ContactUs_module_default()).formTitle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (ContactUs_module_default()).formSubtitle,
                            children: [
                                "Fill in this form or",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkWrapper/* default */.Z, {
                                    path: "mailto:".concat(contacts/* EMAIL_LINK */.Vr),
                                    children: "send us an e-mail"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (ContactUs_module_default()).formAndContacts,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm["default"], {
                            isBudgetSlider: true,
                            className: (ContactUs_module_default()).form,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Contacts, {
                                className: (ContactUs_module_default()).contacts
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CompanyPlacementWithMap, {
                        className: (ContactUs_module_default()).addresses
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSection["default"], {
                        section: peoplePhotoSection,
                        type: "contact"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_ContactUs = (ContactUs);

;// CONCATENATED MODULE: ./pages/contact.js

var __N_SSG = true;
/* harmony default export */ var contact = (views_ContactUs);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oO": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* unused harmony exports useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96076);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91217);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);












var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                queryFn: function queryFn(value) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var client, ref, ref1, response, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: {}
                                            }
                                        ];
                                    }
                                    client = utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_FALLBACK_CONTENTFUL.includes */ .Bt.includes(value) ? utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient : utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulClient;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        client.getEntries({
                                            contentType: "page",
                                            additionalQueryParams: {
                                                "fields.slug": value
                                            }
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    data = (response === null || response === void 0 ? void 0 : (ref = response.items) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.fields) || {};
                                    return [
                                        2,
                                        {
                                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                                                metaData: {
                                                    metaTitle: data.metaTitle || "",
                                                    metaDescription: data.metaDescription || "",
                                                    metaRobots: data.metaRobots || "",
                                                    ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getFileUrl */ .qm)(data.ogImage)
                                                }
                                            })
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResult: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResultFallback: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql,
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery, useGetPageSearchResultQuery = pageApi.useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery = pageApi.useGetPageSearchResultFallbackQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (pageApi);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.breadcrumpsTitle */ .y2.portfolio.breadcrumpsTitle
            });
            if (title && slug) {
                var cleanTitle = (title === null || title === void 0 ? void 0 : title.replace(/\s*\[Case Study\].*$/, "").trim()) || "";
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: cleanTitle
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 45137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyLocation_container__Wosvc","addressTitle":"CompanyLocation_addressTitle__hLc4R","addressText":"CompanyLocation_addressText__y9Hne"};

/***/ }),

/***/ 17002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__dXRIP","controlPanel":"styles_controlPanel__oey44","marker":"styles_marker__e6_TM"};

/***/ }),

/***/ 32156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactHeadline":"Contacts_contactHeadline__86T9u","contact":"Contacts_contact__Nr1au","smItem":"Contacts_smItem__0a5aQ"};

/***/ }),

/***/ 42222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__EQ1kE","updatedAt":"styles_updatedAt__pww8i"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 39323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"companyPlacement":"CompanyPlacementWithMap_companyPlacement__L55wa","content":"CompanyPlacementWithMap_content__7ejkh","title":"CompanyPlacementWithMap_title__Ksukq","addressesContainer":"CompanyPlacementWithMap_addressesContainer__2ilq3","address":"CompanyPlacementWithMap_address__vU7eQ"};

/***/ }),

/***/ 13373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__wyX6Z","cards":"styles_cards__sG8g3","imageWrapper":"styles_imageWrapper__1b33b","typeTitle":"styles_typeTitle__V5kul","greySection":"styles_greySection__73wyr","callToAction":"styles_callToAction__XLjF4","threeColumnsCards":"styles_threeColumnsCards___HEbp","twoColumnsCards":"styles_twoColumnsCards__oqyFL","textContent":"styles_textContent__ZqEJn","container":"styles_container__sI3jf","imageSection":"styles_imageSection__evjm8","image":"styles_image__UcfgE","titleStyle":"styles_titleStyle__NHwH_","experienceContent":"styles_experienceContent__gJJdn","blackSection":"styles_blackSection__1ZH_j","crowdfunding-platform-development-company":"styles_crowdfunding-platform-development-company__QtPfR","chat-app-development-company":"styles_chat-app-development-company__je2VW","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__wyZ2M","fintech-software-development-services":"styles_fintech-software-development-services__RE_eH","trading-software-development":"styles_trading-software-development__c9nG5","firstSectionView":"styles_firstSectionView__T_xFS","secondSectionView":"styles_secondSectionView__HmmuW","penetration-testing":"styles_penetration-testing__Lvjph","e-wallet-app-development":"styles_e-wallet-app-development__848eE","delivery-quality-in-yellow":"styles_delivery-quality-in-yellow__BYuDr","thirdSectionView":"styles_thirdSectionView__Q2_ra","billing-software-development-services":"styles_billing-software-development-services__uhe4C","contact":"styles_contact__xaYyM","why-us":"styles_why-us__UY5LB","software-quality-assurance-services":"styles_software-quality-assurance-services__G_k65","deep-learning":"styles_deep-learning__MRFcz","natural-language-processing-as-a-service":"styles_natural-language-processing-as-a-service__60SgV","beyond-the-hype":"styles_beyond-the-hype__Ax7Vv","llm-use-cases-webinar":"styles_llm-use-cases-webinar__0lEY0","beyond-chatbots-webinar":"styles_beyond-chatbots-webinar__9OxwI"};

/***/ }),

/***/ 60853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formAndContacts":"ContactUs_formAndContacts__8_qyd","formContainer":"ContactUs_formContainer__pmwQX","formTitle":"ContactUs_formTitle__xPJQ2","formSubtitle":"ContactUs_formSubtitle__J6Rg2","form":"ContactUs_form__mzBvh","contacts":"ContactUs_contacts__u4Ezl","addresses":"ContactUs_addresses__feUKB"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullLayout":"styles_fullLayout__pin3O","disableOverflowHiding":"styles_disableOverflowHiding__LcGJo","disableMaxWidth":"styles_disableMaxWidth__V_d1K","disableSidePadding":"styles_disableSidePadding__Ybgq_","disableTopPadding":"styles_disableTopPadding__PX_CS","disableBottomPadding":"styles_disableBottomPadding__8xmaX","alabaster":"styles_alabaster__keXtu"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,33714,52634,25675,74129,24168,84602,21148,43919,74130,6778,57330,13107,15805,96419,98971,49163,49774,92888,40179], function() { return __webpack_exec__(48105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);